var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"d-lg-block"},[_vm._v("MijnVerenigingsWeb © "+_vm._s(new Date().getFullYear()))])])}
var staticRenderFns = []

export { render, staticRenderFns }